<template minapp='mpx' xlang='wxml'>
	<es-layout
		leftArrow
		navbarTitle="改签详情"
		custom-class="nav"
		custom-title="custom-title"
		custom-navbar="custom-navbar"
		layout="{{['header', 'footer']}}"
		navbarStyle="{{navbarStyle}}"
		useBlankPage="{{loadingPage||loadInitDataFail}}"
		blankPageType="{{ loadingPage ? 'loading' : loadInitDataFail ? 'blank-page' :''}}"
		esMainStyle="{{loadingPage ? esLoadingStyle :esMainStyle}}"
		blankContextSubTitle="{{loadFailText}}"
		bind:blank-retry="loadChangeDetail"
		bind:scrolling="pageScroll"
	>
		<view
			bindtouchstart="touchStart"
			bindtouchmove="touchMove"
			bindtouchend="touchEnd"
			wx:style="transform:{{transformY}};"
		>
			<view class="pulldown" wx:if="{{showPullDown}}">
				<image src="{{loadingImg}}" class="pulldown-loading" />
				<view class="pulldown-text">松开立即刷新</view>
			</view>
			<train-swiper
				initIndex="{{ currentIndex }}"
				bind:change="onChange"
				showReason="{{false}}"
				listData="{{changeDetailList}}"
			/>
			<view wx:class="order-info-bg" wx:if="{{currentData}}">
				<order-flow-info
					currOrder="{{currentData}}"
					list="{{currentData != null ? currentData.time_sequence : []}}"
				>
					<view slot="title">
						<view class="order-title" bindtap="onShowPriceDetail">
							<view wx:style="align-items:center; display:flex"
								><es-icon size="24" name="{{iconName}}" class="order-left" />{{
									currentData != null ? currentData.status_name : ''
								}}</view
							>
							<view wx:if="{{showPriceSub}}">
								<view class="order-price-detail">费用明细<es-icon size="16" name="angle-right" /></view>
							</view>
						</view>
					</view>
				</order-flow-info>
			</view>
			<view style="margin-left: 12px">
				<ticket-card ticketInfo="{{oldTicketInfo}}" />
			</view>
		</view>
	</es-layout>
	<price-detail-info-alter
		wx:if="{{currentData}}"
		show="{{showPriceDetail}}"
		priceDetail="{{currentData.fee_detail}}"
		bind:close="closePriceDetail"
	/>
</template>

<script>
 	import { createPage, mpx } from '@didi/es-mpx-creator'
 	import { CHANGE_DETAIL } from '@/api/urls'
 	import { LOAD_FAIL_CONTENT, DIDI_REQUEST } from '@/common/constant'
 	import { getFinalPrice } from '../../utils/money'
 	import { STORAGE_CURRENT_CHANGE_TICKET_ID } from '@/utils/train-storage'
 	import { getStorage, setStorage } from '@/utils/storage'

 	createPage({
 		data() {
 			return {
 				loadFailText: '',
 				navbarStyle: {
 					background: '#1473FF',
 					color: '#FFF'
 				},
 				esMainStyle: {
 					background: '#f0f1f4',
 					'background-image':
 						'linear-gradient(180deg, #1473ff 0%, #1473ff 30%, #f0f1f4 30%, #f0f1f4 100%)'
 				},
 				esLoadingStyle: {
 					background: '#f0f1f4'
 				},
 				changeDetailList: [],
 				currentIndex: 0,
 				currentData: null,
 				timeSequence: null,
 				loadInitDataFail: true,
 				loadingPage: true,
 				showPriceDetail: false, // 展示费用明细弹窗
 				touchStartHeight: 0, // 滑动touchstart的距离顶部高度
 				recordScrollHeight: 0, // 记录滑动的高度
 				clientY: -1, // 滑动开始时Y
 				changeClientY: 0,
 				platform: 'android', // 设备
 				showPullDown: false,
 				loadingImg: 'https://pt-starimg.didistatic.com/static/starimg/img/Hc2LzFVPzU1652950957080.png',
 				selectedTicketId: '',
 				oldTicketInfo: {}
 			}
 		},
 		computed: {
 			// 向下滑动的距离
 			transformY() {
 				// ios使用原生滑动
 				if (this.platform === 'ios') {
 					return 'translateY(0px)'
 				} else {
 					return 'translateY(' + this.changeClientY + 'px)'
 				}
 			},
 			showPriceDetailButton() {
 				return this.currentData?.ticket_price != undefined
 			},
 			iconName() {
 				return this.showPriceDetailButton ? 'check-circle' : 'time'
 			},
 			showPriceSub() {
 				var length = this.currentData?.time_sequence?.length
 				return this.currentData?.time_sequence[length - 1]?.is_success === 1 && this.showPriceDetailButton
 			}
 		},
 		methods: {
 			// 加载退票详情
 			loadChangeDetail(refresh) {
 				const { order_id } = this.$mpxRoute.query
 				const params = { order_id: order_id, show_loading: false }
 				DIDI_REQUEST(CHANGE_DETAIL, params, ({ data, code, message }) => {
 					if (code === '0') {
 						this.loadInitDataFail = false
 						const { change_ticket_info } = data
 						this.changeDetailList = change_ticket_info
 						let cur_ticket_id = getStorage(STORAGE_CURRENT_CHANGE_TICKET_ID)
 						this.changeDetailList?.map((item, index) => {
 							if (item.pre_ticket_id === cur_ticket_id || item.ticket_id === cur_ticket_id) {
 								this.currentIndex = index
 							}
 						})
 						this.currentData =
 							this.currentIndex < (this.changeDetailList?.length ?? 0)
 								? this.changeDetailList[this.currentIndex]
 								: null
 						this.oldTicketInfo = {
 							pre_from_station_name: this.currentData?.pre_from_station_name,
 							pre_to_station_name: this.currentData?.pre_to_station_name,
 							pre_start_time: this.currentData?.pre_start_time,
 							pre_train_code: this.currentData?.pre_train_code
 						}
 					} else {
 						this.loadInitDataFail = true
 						this.loadFailText = message
 					}
 				})
 					.catch((e) => {
 						this.loadInitDataFail = true
 						this.loadFailText = LOAD_FAIL_CONTENT
 					})
 					.finally(() => {
 						this.loadingPage = false
 					})
 			},
 			onChange(event) {
 				this.currentIndex = event.detail
 				this.currentData = this.changeDetailList?.[this.currentIndex]
 				this.oldTicketInfo = {
 					pre_from_station_name: this.currentData.pre_from_station_name,
 					pre_to_station_name: this.currentData.pre_to_station_name,
 					pre_start_time: this.currentData.pre_start_time,
 					pre_train_code: this.currentData.pre_train_code,
 					reason: this.currentData.reason
 				}
 				setStorage({
 					key: STORAGE_CURRENT_CHANGE_TICKET_ID,
 					data: this.currentData?.ticket_id
 				})
 			},
 			onShowPriceDetail() {
 				//如果已经退票成功了 那么点击唤起弹窗 否则无反应
 				if (this.currentData?.ticket_price != undefined) {
 					this.showPriceDetail = true
 				}
 			},
 			closePriceDetail() {
 				this.showPriceDetail = false
 			},

 			// 滚动中事件
 			pageScroll({ detail: e }) {
 				const { scrollTop } = e.detail
 				this.recordScrollHeight = scrollTop
 			},

 			touchStart(e) {
 				this.clientY = e.changedTouches[0].clientY
 				this.touchStartHeight = this.recordScrollHeight
 			},

 			touchMove(e) {
 				// 获取滑动中的y值
 				let clientY = e.changedTouches[0].clientY
 				// 如果时顶部开始滑动，并且像下滑动，就改变tranlate等于改变的差值
 				if (this.touchStartHeight < 30 && clientY > this.clientY && this.clientY !== -1) {
 					let changY = Math.trunc(clientY - this.clientY)
 					if (this.platform !== 'ios') {
 						this.changeClientY = changY > 90 ? 90 : changY
 					}
 					this.showPullDown = true
 				}
 			},

 			touchEnd(e) {
 				if (this.touchStartHeight < 30 && this.clientY !== -1) {
 					let clientY = e.changedTouches[0].clientY
 					let changY = Math.trunc(clientY - this.clientY)
 					if (this.platform !== 'ios') {
 						this.changeClientY = 0
 					}
 					if (changY > 90) {
 						this.loadChangeDetail(true)
 					}
 				}
 				this.showPullDown = false
 			}
 		},

 		created() {
 			const { selected_ticket_id } = this.$mpxRoute.query
 			//改签详情页面多人时，支持滑动 由A滑动到B 刷新时要展示B的
 			setStorage({
 				key: STORAGE_CURRENT_CHANGE_TICKET_ID,
 				data: selected_ticket_id
 			})
 			this.loadChangeDetail()
 		},

 		mounted() {
 			mpx.setNavigationBarColor({ frontColor: '#ffffff' })
 		},

 		destroyed() {
 			mpx.removeStorage({
 				key: STORAGE_CURRENT_CHANGE_TICKET_ID
 			})
 		}
 	})
</script>

<style lang='stylus' scoped>
 @import '~@/mixins/stylus/color.styl'

 .pulldown
 	display flex
 	justify-content center
 	align-items center
 	width 100%
 	height 40px
 .pulldown-text
 	font-size 14px
 	color #FFFFFF
 	padding-right 28px
 .pulldown-loading
 	width 20px
 	height 20px
 	margin-right 15px
 	animation spin 2s linear infinite
 @keyframes spin
 	0%
 		transform rotate(0deg)
 	100%
 		transform rotate(360deg)
 .custom-title
 	font-size 18px
 	font-family PingFangSC
 .nav
 	/deep/ .es-navbar
 		background-color $train-color-theme-blue
 		color #ffffff
 		font-family PingFangSC
 		font-size 18px
 .custom-navbar
 	background-color $train-color-theme-blue
 	color #ffffff
 	font-family PingFangSC
 	font-size 18px
 .list-main
 	padding-bottom 10px
 	box-sizing border-box
 .order-info-bg
 	background-color rgb(240, 241, 244)
 	height 100%
 	padding 12px
 	box-sizing border-box
 	border-radius 12px 12px 0px 0px
 	overflow auto
 .order-title
 	color $train-color-theme-blue
 	font-size 16px
 	height 69px
 	font-weight 600
 	display flex
 	align-items center
 	flex-direction row
 	justify-content space-between
 .order-price-detail
 	display flex
 	font-size 12px
 	font-weight 400
 	color $train-color-999
 	justify-content flex-end
 	align-items center
 .order-left
 	margin-right 6px
</style>

<script name='json'>
 	module.exports = {
 		navigationBarTitleText: '',
 		usingComponents: {
 			// 'es-layout': '@didi/es-mpx-ui/lib/scroll-layout',
 			'train-swiper': '../refund-ticket/components/train-swiper-card.mpx',
 			'refund-detail-info-alert': '../refund-ticket/components/refund-detail-info-alert',
 			'order-flow-info': '@/components/order-flow-info',
 			'price-detail-info-alter': '@/components/price-detail-info-alter',
 			'ticket-card': './components/change-ticket-card'
 		}
 	}
</script>